import React, { Component } from "react";
import { formatISO } from "date-fns";

import ConfigService from "../../../services/ConfigService";
import CoreService from "../../../services/CoreService";
import AuthService from "../../../services/AuthService";
import AuthResourceService from "../../../services/AuthResourceService";
import LocalDbService from "../../../services/LocalDbService";
import LocalImageDbService from "../../../services/LocalImageDbService";
import LocalDocumentDbService from "../../../services/LocalDocumentDbService";
import LocalStorageService from "../../../services/LocalStorageService";
import BlobStorageService from "../../../services/BlobStorageService";

//import EnvironmentManager from "../../../pages/Observation/Components/Managers/EnvironmentManager";
import SubscriptionManager from "../../../managers/SubscriptionManager";
import FileManager from "../../../managers/FileManager";
import DataApiManager from "../../../managers/DataApiManager";

import JavascriptHelpers from "../../../components/lib/Javascript/JavascriptHelpers";
import JwtToken from "../../../components/lib/tokens/JwtToken";

import HealthInfo from "../../../models/HealthInfo";
import HealthInfoDetail from "../../../models/HealthInfoDetail";
import { HealthStatusType } from "../../../models/HealthStatusType";

import ErrorEvent from "../../../models/ErrorEvent";
import ServiceResponse from "../../../models/ServiceResponse";




function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export default class LotWatcher extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isRunning: false,
      watchListLastUpdated: JavascriptHelpers.isoUtcNow(),
    };

    this.configService = new ConfigService();
    this.coreService = new CoreService();
    this.authService = new AuthService();
    this.authResourceService = new AuthResourceService();
    this.localImageDbService = new LocalImageDbService();
    this.localDocumentDbService = new LocalDocumentDbService();
    this.blobStorageService = new BlobStorageService();
    this.localObsDbService = new LocalDbService("observation", "obsDb", [{field: "offlineId", name: "offlineId", unique: true}]);
    this.localStorageService = new LocalStorageService();
    this.watchInterval = new ConfigService().getWatchInterval(); // milliseconds

    this.start = this.start.bind(this);
    this.stop = this.stop.bind(this);
    this.refreshWatchListQueue = this.refreshWatchListQueue.bind(this);
    this.processExpirationCheck = this.processExpirationCheck.bind(this);
    this.processLocalQueue = this.processLocalQueue.bind(this);
    this.processHealthCheck = this.processHealthCheck.bind(this);
    this.interval = null;

    this.dataApiManager = new DataApiManager();
  }

  componentWillUnmount() 
  {
    this.stop();
  }

  componentDidUpdate(prevProps, prevState) 
  {
    if (this.props.runLotWatcher !== prevProps.runLotWatcher) {
      console.log(
        "Watcher was commanded to " + this.props.runLotWatcher
          ? "start"
          : "stop"
      );
      this.stop();
      if (this.props.runLotWatcher) {
        this.start();
      }
    }
  }

  async start() 
  {
    if (this.state.isRunning) return;
    console.log("Starting Watcher...");
    this.interval = setInterval(() => {
      this.refreshWatchListQueue();
    }, this.watchInterval);
  }

  stop() 
  {
    console.log("Stopping Watcher");
    this.setState({ isRunning: false });
    clearInterval(this.interval);
  }


  // this is actually our MAIN loop, so health checks, etc may be done here. 
  async refreshWatchListQueue() 
  {
    try {
      this.setState({ isRunning: true });
      /*
      this.props.onLotWatcherRunningStatusChange(true);
      
      this.stop();

      if (!this.processExpirationCheck()) return;
      await this.processLocalQueue();
      */
      await this.processHealthCheck();

      
      if (this.props.autoRefresh) this.props.onTriggerAutoRefresh();
      
      this.setState({ watchListLastUpdated: JavascriptHelpers.isoUtcNow() });
      
    } 
    catch(e) {
      this.props.onToastRequest("error", "There was a unexpected problem with the main loop");
      // TBD - Okay. What do we do with this?
    } 
    finally {
      this.setState({ isRunning: false });
      this.props.onLotWatcherRunningStatusChange(false);
      this.start();
    }
      
  }


  processExpirationCheck()
  {
    if (!this.props.userSession) return false;
    this.props.updateSessionExpiration(JwtToken.toExpiredDateTime(this.props.userSession.token));
    if (JwtToken.isTokenExpired(this.props.userSession.token)) 
    {
      console.group("Token Expiration Check");
      console.log("The user token has expired.");
      console.info(this.props.userSession.token);
      console.groupEnd();
      this.stop();
      this.props.onExpiredToken(this.props.userSession.token);
      return false;
    }
    return true;
  }

  async processLocalQueue()
  {

       var localQueueResponse = new ServiceResponse(false, []);
       var isEmptyQueue = true;

      try
      {


      } catch(overallErr)
      {
        console.info(overallErr);
        localQueueResponse.hasError = true;
        localQueueResponse.messages.push("There was an unexpected error running the posting loop.");
        localQueueResponse.messages.push(overallErr.toString());
      }
      finally 
      {
        try
        {
          if (isEmptyQueue) return; // do not log if nothing was waiting!
          var orgConfig = this.localStorageService.getOrgConfig(this.props.userSession.gcid);
          if (!orgConfig.logging?.enabled) return;
          if ((orgConfig.logging.errorsOnly) && (!localQueueResponse.hasError)) return;
          var logEvent = new ErrorEvent(this.props.userSession.gcid, formatISO(new Date()), "itrace.watcher", this.props.userSession.uid, this.props.userSession.uid);
          logEvent.errorCode = (localQueueResponse.hasError) ? "1": "0";
          logEvent.errorDescription = "Main update loop";
          logEvent.comments = "from lotWatcher";
          logEvent.stackTrace = JSON.stringify(localQueueResponse);

          var saveLogResponse = await this.coreService.postErrorEvent(logEvent, this.props.userSession.gcid, this.props.userSession.token);
          if (saveLogResponse.hasError)
          {
            this.props.onToastRequest("error", "There was a problem saving loop posting log data. Please report the following error to your Application Administrator -[" + logEvent.stackTrace() + "]");

          }
        }
        catch (finallyErr)
        {
          this.props.onToastRequest("error", "There was a problem saving loop posting log data. Please report the following error to your Application Administrator -[" + finallyErr.toString() + "]");

        }
      }

  }




  toHealthInfoDetail(serviceName, updateDateTime, dbResponse)
  {
    var result = new HealthInfoDetail(serviceName, updateDateTime, 
      (dbResponse.hasError) ? HealthStatusType.ERROR : HealthStatusType.OK,
      (dbResponse.hasError) ? dbResponse.messages : "Ok"
    );
  }



  async processHealthCheck()
  {
    var hasPrevInfo = (this.props.healthInfo);

    var corePingResponse = await this.coreService.pingCore();
    var coreDbPingResponse = await this.coreService.pingCoreDb();
    var authPingResponse = await this.authService.ping(this.props.userSession.token);
    var authResourcePingResponse = await this.authResourceService.pingCore(this.props.userSession.token);
    // tbd - check coreservice for adapter log.
    //var adapterLogResponse = await this.coreService.get

    // if the current update has an error, then the last problem update BECOMES the current Update
    // If there is NO lastProblemUpdate AND the currentUpdate is NOT an error, then leave it null.
    // If there is a lastProblemUpdate AND the currentUpdate is NOT an error, then set to lastProblemUpdate.

    var newHealthInfo = new HealthInfo(this.props.userSession.gcid, this.props.userSession.uid, this.props.userSession.currentLocationId, JavascriptHelpers.isoNow());
    
    newHealthInfo.coreHealth.currentUpdate = new HealthInfoDetail("core-api", formatISO(new Date()), (corePingResponse.hasError) ? HealthStatusType.ERROR: HealthStatusType.OK, (corePingResponse.messages) ? corePingResponse.messages : []);
      newHealthInfo.coreHealth.lastProblemUpdate = (corePingResponse.hasError) ? 
      newHealthInfo.coreHealth.currentUpdate 
      : (this.props.healthInfo?.coreHealth?.lastProblemUpdate) ? this.props.healthInfo.coreHealth.lastProblemUpdate : null;

    newHealthInfo.coreDbHealth.currentUpdate = new HealthInfoDetail("core-db", formatISO(new Date()), (coreDbPingResponse.hasError) ? HealthStatusType.ERROR: HealthStatusType.OK, (coreDbPingResponse.messages) ? coreDbPingResponse.messages : []);
        newHealthInfo.coreDbHealth.lastProblemUpdate = (coreDbPingResponse.hasError) ? 
        newHealthInfo.coreDbHealth.currentUpdate 
        : (this.props.healthInfo?.coreDbHealth?.lastProblemUpdate) ? this.props.healthInfo.coreDbHealth.lastProblemUpdate : null;

    newHealthInfo.authHealth.currentUpdate = new HealthInfoDetail("auth-api", formatISO(new Date()), (authPingResponse.hasError) ? HealthStatusType.ERROR: HealthStatusType.OK, (authPingResponse.messages) ? authPingResponse.messages : []);
        newHealthInfo.authHealth.lastProblemUpdate = (authPingResponse.hasError) ? 
          newHealthInfo.authHealth.currentUpdate 
          : (this.props.healthInfo?.authHealth?.lastProblemUpdate) ? this.props.healthInfo.authHealth.lastProblemUpdate : null;

  
    newHealthInfo.authResourceHealth.currentUpdate = new HealthInfoDetail("auth-api", formatISO(new Date()), (authResourcePingResponse.hasError) ? HealthStatusType.ERROR: HealthStatusType.OK, (authResourcePingResponse.messages) ? authResourcePingResponse.messages : []);
          newHealthInfo.authResourceHealth.lastProblemUpdate = (authResourcePingResponse.hasError) ? 
            newHealthInfo.authResourceHealth.currentUpdate 
            : (this.props.healthInfo?.authResourceHealth?.lastProblemUpdate) ? this.props.healthInfo.authResourceHealth.lastProblemUpdate : null;

    // TBD - this is NOT just an api call. We can't "call" the API from here. Instead we need to ask the core service adapter log to vongitm we're getting pings
    newHealthInfo.adapterHealth.currentUpdate = new HealthInfoDetail("auth-api", formatISO(new Date()), (authResourcePingResponse.hasError) ? HealthStatusType.ERROR: HealthStatusType.OK, (authResourcePingResponse.messages) ? authResourcePingResponse.messages : []);
          newHealthInfo.authResourceHealth.lastProblemUpdate = (authResourcePingResponse.hasError) ? 
            newHealthInfo.authResourceHealth.currentUpdate 
            : (this.props.healthInfo?.authResourceHealth?.lastProblemUpdate) ? this.props.healthInfo.authResourceHealth.lastProblemUpdate : null;
     
            this.props.onHealthInfoUpdate(newHealthInfo); 

  }





  render() 
  {
    return (<span />);
  }
}
